import { render, staticRenderFns } from "./SettingLayout.vue?vue&type=template&id=5cd54e4a&scoped=true"
import script from "./SettingLayout.vue?vue&type=script&lang=js"
export * from "./SettingLayout.vue?vue&type=script&lang=js"
import style0 from "./SettingLayout.vue?vue&type=style&index=0&id=5cd54e4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd54e4a",
  null
  
)

export default component.exports